// src/components/RotatingImage.tsx

import React, { useEffect, useState } from 'react';

import img from '../../Images/Gear.png'

function useViewportWidth(): number {
  const [viewportWidth, setViewportWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewportWidth;
}


const Rotator: React.FC = () => {
  const [rotation, setRotation] = useState<number>(0);

  const width = useViewportWidth();
  const isNarrow = width < 991;

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setRotation(scrollTop / 10); // Keep rotation within 0-359 degrees
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      <img
        src={img}
        alt="Rotating"
        className='rotating-image'
        style={{
          position: 'fixed',
          top: `${isNarrow ? width * .04 :-width * 0.02}px`,
          right: `-${width * 0.1}px`,
          width: `${width * 0.2}px`,
          height: `${width * 0.2}px`,
          zIndex: 2,
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.1s linear',
        }}
      />
      <img
        src={img}
        alt="Rotating"
        className='rotating-image'
        style={{
          position: 'fixed',
          bottom: `-${width * 0.1}px`,
          left: `-${width * 0.1}px`,
          width: `${width * 0.2}px`,
          height: `${width * 0.2}px`,
          zIndex: 10000,
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.1s linear',
        }}
      />
    </div>

  );
};

export default Rotator;